import { Empty } from "antd";
import { cn } from "@/shared/lib/utils";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  variant?: "card" | "compact";
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  variant = "card",
  action,
  className,
}: EmptyStateProps) {
  if (variant === "compact") {
    return (
      <p className={cn("py-4 text-center text-sm text-[#9CA3AF]", className)}>
        {title}
      </p>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-2xl border border-[#E5E7EB] bg-white py-16 text-center shadow-sm",
        className,
      )}
    >
      <Empty
        image={icon ?? Empty.PRESENTED_IMAGE_SIMPLE}
        description={false}
        className="[&_.ant-empty-image]:!h-12 [&_.ant-empty-image]:!mb-0 [&_.ant-empty-image_svg]:!text-[#9CA3AF]"
      />
      <p className="mt-4 text-sm font-semibold text-[#0A2947]">{title}</p>
      {description && <p className="mt-1 max-w-xs text-xs text-[#9CA3AF]">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
